export const textForbiddenChars = /[<>/"`=;(){}]/;
export const textAreaForbiddenChars = /[<>]/;
